/*
  import { boardDocumentStore } from '@/services/BoardDocument/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import _get from 'lodash/get'
import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await escrowStore.dispatch ('getEscrowList', {
      hoaId
    });
  */

  async getBoardDocumentList({}, { hoaID }) {
    console.log('in getBoardDocumentList...' + hoaID)
    try {
      const results = await kms.get(`/BoardDocuments/BoardDocument/List?hoaID=${hoaID}`)

      if (isDebug == true) console.debug('getBoardDocumentList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Board Document list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getBoardDocumentById({}, { boardDocumentID }) {
    try {
      console.debug('in getBoardDocumentById...')
      const result = await kms.get(`/BoardDocuments/BoardDocument/${boardDocumentID}`)

      if (isDebug == true) console.debug('getBoardDocumentById=' + JSON.stringify(result))

      return {
        result: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving this board document detail.`)
      console.error(exception)
    }

    return {
      result: {}
    }
  },

  async getDocumentFile({ dispatch }, { params, done }) {
    const path = `/BoardDocuments/BoardDocument/GetFile`
    const result = await kms.get(path, {
      params
    })

    if (this.isDebug == true) console.debug('getDocumentFile=' + JSON.stringify(result))

    if (dispatch && dispatch != undefined) console.debug(dispatch)

    if (result) {
      console.debug(`Successfully retrieved the board document.`)
      done({ details: result })
    } else {
      console.error('There was a problem retrieving the board document.')
    }
  },

  async addBoardDocument(
    { dispatch },
    { hoaID, boardDocumentID, boardDocumentCategoryID, description, done }
  ) {
    try {
      const result = await kms.post(`/BoardDocuments/BoardDocument/`, {
        hoaID,
        boardDocumentID,
        boardDocumentCategoryID,
        description
      })

      console.debug('result=' + JSON.stringify(result))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (result.boardDocumentID > 0) {
        console.debug(`Successfully added the board document.`)
        done({ details: result })
      } else {
        console.debug('There was a problem adding the board document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem adding this board document.`)
      console.error(exception)
    }
  },

  async deleteBoardDocument({ dispatch }, { boardDocumentID, done }) {
    try {
      const path = `/BoardDocuments/BoardDocument/${boardDocumentID}?forceDelete=false`

      const results = await kms.delete(path)

      if (isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted this board document.`)
        done()
      } else {
        notifyError('There was a problem deleting this board document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting this board document.`)
      console.error(exception)
    }
  },

  async updateBoardDocument({ dispatch }, { payload = {}, done }) {
    try {
      const results = await kms.put(`/BoardDocuments/BoardDocument`, payload)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.boardDocumentID > 0) {
        notifyMessage(`Successfully updated the board document.`)
        done()
      } else {
        notifyError('There was a problem updating this board document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem processing the update for this board document.`)
      console.error(exception)
    }
  },

  async uploadDocument({ dispatch }, { payload = {}, done }) {
    const formData = new FormData()
    formData.append('file', payload.file)

    try {
      const path = `/BoardDocuments/BoardDocument/StoreFile?boardDocumentID=${payload.boardDocumentID}`
      const uploadedBoardDocumentFile = await kms.post(path, formData, {
        'Content-Type': 'multipart/form-data'
      })

      console.debug('uploadDocument path=' + path)

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (isDebug == true)
        console.debug(
          'upload board document with payload=' + JSON.stringify(uploadedBoardDocumentFile)
        )

      done({ returnedFile: uploadedBoardDocumentFile })
    } catch (e) {
      notifyError(e)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const boardDocumentStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
